import { GET_USERS, LOGOUT } from '../../constants/actionTypes';

const initialState = {};

export default function users(state = initialState, action = {}) {
  switch (action.type) {
    case GET_USERS:
      let list = action.payload.Data;
      let updated = [];
      for (let i = 0; i < list.length; i++) {
        updated.push({
          ...list[i],
          key: (list[i].ID - 1).toString(),
          password: '',
        });
      }
      return {
        ...action.payload,
        Data: updated,
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
